import { render, staticRenderFns } from "./VerDialog.vue?vue&type=template&id=5b07c020&scoped=true"
import script from "./VerDialog.vue?vue&type=script&lang=js"
export * from "./VerDialog.vue?vue&type=script&lang=js"
import style0 from "./VerDialog.vue?vue&type=style&index=0&id=5b07c020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07c020",
  null
  
)

export default component.exports